import React, { useMemo } from 'react'
import LiveHelpIcon from '@mui/icons-material/LiveHelp';
import { Badge } from '@mui/material';
import useChatNotificationService from '../../hooks/useChatNotificationService';

const ChatHeader = () => {
  const { allChats } = useChatNotificationService();

  const counts = useMemo(() => {
    let buying = 0;
    let selling = 0;
    let support = 0;
    let all = 0;

    allChats?.forEach(chat => {
      const count = chat.messageCount || 0;
      all += count;

      // Support chats usually have productId 0
      if (chat.productId === 0 || chat.type?.toLowerCase() === 'support') {
        support += count;
      } else if (chat.type?.toLowerCase() === 'buy') {
        buying += count;
      } else if (chat.type?.toLowerCase() === 'sell') {
        selling += count;
      }
    });

    return { buying, selling, support, all };
  }, [allChats]);

  return (
    <ul className="nav nav-tabs" id="myTab" role="tablist">
      <li className="nav-item tabs-design active" role="presentation">
        <button
          className="nav-link   active"
          id="home-tab"
          data-toggle="tab"
          data-target="#home"
          type="button"
          role="tab"
          aria-controls="home"
          aria-selected="true"
        >
          <Badge badgeContent={counts.all} color="error" sx={{ '& .MuiBadge-badge': { right: -10, top: 0 } }}>
            All
          </Badge>
        </button>
      </li>
      <li className="nav-item tabs-design" role="presentation">
        <button
          className="nav-link  "
          id="profile-tab"
          data-toggle="tab"
          data-target="#profile"
          type="button"
          role="tab"
          aria-controls="profile"
          aria-selected="false"
        >
          <Badge badgeContent={counts.buying} color="error" sx={{ '& .MuiBadge-badge': { right: -10, top: 0 } }}>
            Buying
          </Badge>
        </button>
      </li>
      <li className="nav-item tabs-design" role="presentation">
        <button
          className="nav-link  "
          id="messages-tab"
          data-toggle="tab"
          data-target="#messages"
          type="button"
          role="tab"
          aria-controls="messages"
          aria-selected="false"
        >
          <Badge badgeContent={counts.selling} color="error" sx={{ '& .MuiBadge-badge': { right: -10, top: 0 } }}>
            Selling
          </Badge>
        </button>
      </li>
      <li className="nav-item tabs-design" role="presentation" style={{ float: "right" }}>
        <button
          className=""
          id="messages-tab"
          data-toggle="tab"
          data-target="#support"
          type="button"
          role="tab"
          aria-controls="support"
          aria-selected="false"
          style={{ paddingBottom: "4px" }}
        >
          <Badge badgeContent={counts.support} color="error" sx={{ '& .MuiBadge-badge': { right: -5, top: 5 } }}>
            <LiveHelpIcon />
          </Badge>
        </button>
      </li>
    </ul>
  )
}

export default ChatHeader;